// extracted by mini-css-extract-plugin
export default {"json":"JsonComponent_json__I0YG1"};